<template>
  <div popup>
    <div class="dim"></div>
    <div class="holder">
      <slot/>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/asset";
  @import "../less/gynpad";

  [popup] { .abs; z-index: 50; .lt; width:100%;
    .dim { .flt; width:100%; height:120%; background: rgba(0,0,0,0.8); z-index: 50; }
    .holder { .lt; z-index: 51; width: 100%;}
  }

  @media (min-width: @screen-lg-min) {
    [popup] {

    }
  }
</style>

<script>
import { getScrollBody, getOffsetTop } from '../util';

export default {
  name: 'Popup',
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
    const holder = this.$el.querySelector('.holder');
    holder.style.top = `${getScrollBody().scrollTop() - getOffsetTop(this.$el)}px`;
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Pop.vue